import { writable, readable } from 'svelte/store';
import request from 'superagent';

export const slashVisible = writable(false);
export const slashItems = writable([]);
//export const slashLocaltion = writable({ x: 0, y: 0, height: 0 });
export const slashProps = writable({ editor: null, range: null });

export const unsavedSubitems = writable([]);

export const schemas = readable([], set => {
    request.get('/ix/schemas.jsr')
    .then(function(r) {
      if (r.ok) return r;
      if (r.code != 401) throw Error(r.statusText);
    })
    .then(resp => {
      set(resp.body.data);
    })
    .catch(resp => {
      console.log(JSON.stringify(resp))
    })
});
